import React from "react";
//
import { Container, Image, ButtonAlt } from "@atoms";
import { HeadingWIcon, CardCta } from "@molecules";
import useLakotaAcDefaultsData from "@staticQueries/lakotaAc/DefaultsQuery";

const IssueHero = ({
  backgroundImage,
  heading,
  copy,
  featuredAction,
  // cards,
}) => {
  const { action } = useLakotaAcDefaultsData();
  const actionCard = featuredAction
    ? {
        ...featuredAction,
        image: featuredAction.metaImage,
        link: {
          link: featuredAction.url,
          text:
            featuredAction.actionCustomCtaText ||
            action.defaultActionCtas[featuredAction.actionType] ||
            "Learn More",
        },
      }
    : null;
  return (
    <div className="relative bg-white pt-32 pb-6 sm:pt-48">
      <div className="absolute inset-0 z-0 min-h-hero bg-brown">
        <div className="absolute bottom-0 left-0 right-0 z-10 h-48 bg-gradient-to-b from-transparent to-gray-light" />
        <div className="absolute inset-0 z-0 opacity-40">
          {backgroundImage && (
            <Image
              image={backgroundImage}
              ixParams={{ gam: 25, shad: 25, sat: 10, exp: -2, con: 25 }}
              fill
            />
          )}
        </div>
      </div>
      <div className="relative z-10">
        <Container>
          <div className="mb-4">
            <ButtonAlt to="/" reverse className="text-white">
              Go to Campaigns
            </ButtonAlt>
          </div>
          <div className="mb-6 max-w-xl">
            <HeadingWIcon heading={heading} copy={copy} inverse />
          </div>
          {actionCard && <CardCta {...actionCard} />}
        </Container>
      </div>
    </div>
  );
};

IssueHero.defaultProps = {};

export default IssueHero;
